import http from 'api/httpClient';

export interface CnLhcDetail {
  cn_number: string;
  from_datetime: string | null;
  to_datetime: string | null;
}

export interface GetLhcCnsResponse {
  lhc_number: string;
  cn_lhcs: CnLhcDetail[];
}

export interface LinkCnLhcResponse {
  message: string;
}

export const getLhcCns = async (lhcNumber: string): Promise<GetLhcCnsResponse> => {
  return http.get<GetLhcCnsResponse>(`/api/v1/cto/lhc/get-lhc-cns?lhc_number=${encodeURIComponent(lhcNumber)}`);
};

export const linkCnToLhc = async (lhcNumber: string, cnNumber: string): Promise<LinkCnLhcResponse> => {
  return http.post<LinkCnLhcResponse>('/api/v1/cto/lhc/link', {
    lhc_number: lhcNumber,
    cn_number: cnNumber,
  });
};
